import { useEffect, useState } from 'react';

/**
 * Quantos pixels o teclado virtual está cobrindo na parte de baixo da tela (0 quando
 * fechado, ou em qualquer navegador sem `visualViewport`).
 *
 * O navegador garante que o CAMPO focado fique visível — não o que vem DEPOIS dele. Por
 * isso botões abaixo do campo (o "Acessar sistema" do login, o "Comentar" do diálogo)
 * ficam atrás do teclado mesmo com o container encolhendo por `dvh`.
 *
 * A VisualViewport informa a área de fato visível; a diferença para a janela é o quanto
 * o teclado cobre. Com esse número dá para reservar espaço embaixo ou encolher o
 * container, e o conteúdo tem para onde subir.
 */
export default function useAlturaTeclado() {
    const [alturaTeclado, setAlturaTeclado] = useState(0);

    useEffect(() => {
        const vv = window.visualViewport;
        if (!vv) return undefined;

        const medir = () => {
            const coberto = Math.max(
                0,
                window.innerHeight - vv.height - vv.offsetTop
            );
            // Limiar: as barras do proprio navegador aparecem e somem com poucas
            // dezenas de pixels, e isso nao e teclado.
            setAlturaTeclado(coberto > 80 ? coberto : 0);
        };

        medir();
        vv.addEventListener('resize', medir);
        vv.addEventListener('scroll', medir);
        return () => {
            vv.removeEventListener('resize', medir);
            vv.removeEventListener('scroll', medir);
        };
    }, []);

    return alturaTeclado;
}
